// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ec61e927","453":"3171fbab","455":"26f37e8b","977":"9f74e2be"}[chunkId] + ".chunk.js";
};